import React, { Fragment } from 'react';
import SimpleOptionCard from '../options/SimpleOptionCard';
import PackageCard from '../options/packageCard/PackageCard';

const OptionCards = ({
  options,
  onChange,
  onDetails,
  isUpdating,
  selectingOption,
  analyticsKey,
  showMarker,
}) => {
  return (
    <>
      {options.map((option) => (
        <Fragment key={option.code}>
          {option.packageOption ? (
            <PackageCard
              option={option}
              onChange={onChange}
              onDetails={onDetails}
              analyticsKey={analyticsKey}
              isUpdating={isUpdating}
              selectingOption={selectingOption}
              stacked
            />
          ) : (
            <SimpleOptionCard
              role="checkbox"
              type="option"
              option={option}
              checked={option.selected}
              onChange={onChange}
              onDetails={onDetails}
              optionMarker={showMarker && option.dealerInstalledLabel}
              selectingOption={selectingOption}
              isUpdating={isUpdating}
              analyticsKey={analyticsKey}
              analyticsKey2={option.description}
              displayOnly={option.alwaysSelected}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default OptionCards;
